"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashEmailForId = hashEmailForId;
exports.getOptions = getOptions;
const constants_1 = require("./constants");
const sha1_1 = require("./sha1");
function getEmail(email) {
    if (email) {
        return email;
    }
    const user = window.analytics.user && window.analytics.user();
    const traits = user ? user.traits() : {};
    return traits ? traits.email : null;
}
function hashEmailForId(email) {
    return (0, sha1_1.hash)(`${email.toLowerCase()}TrustpilotTackingHasherIsCool`).toString();
}
function getOptions(options, newEmail) {
    const email = getEmail(newEmail);
    // Turn off all integrations for test users
    // We don't want to send tracking to amplitude, customer.io etc. for test users
    const isTestUser = email && constants_1.TEST_USER_EMAILS.some((domain) => email.endsWith(domain));
    return isTestUser
        ? {
            integrations: {
                All: false,
            },
        }
        : options;
}
//# sourceMappingURL=utils.js.map